/**
 * Product Media Gallery
 * Desktop: scroll-to thumbnails + sticky thumbs
 * Mobile: horizontal scroll with snap + counter
 */
(function () {
  'use strict';

  const gallery = document.querySelector('[data-product-gallery]');
  if (!gallery) return;

  const main = gallery.querySelector('[data-gallery-main]');
  const thumbs = gallery.querySelectorAll('[data-thumb-index]');
  const mediaItems = gallery.querySelectorAll('.product-page__media');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');

  let currentIndex = 0;
  const total = mediaItems.length;

  /* Thumbnail click -> scroll to image (desktop) */
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const index = parseInt(thumb.dataset.thumbIndex);
      goTo(index);
    });
  });

  /* Mobile: prev/next buttons */
  if (prevBtn) {
    prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
  }

  function goTo(index) {
    if (index < 0) index = 0;
    if (index >= total) index = total - 1;

    currentIndex = index;

    /* Desktop: scroll main to the image */
    if (window.innerWidth >= 990) {
      const target = mediaItems[index];
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      /* Mobile: horizontal scroll */
      const target = mediaItems[index];
      if (target && main) {
        main.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth',
        });
      }
    }

    updateActive(index);
  }

  function updateActive(index) {
    currentIndex = index;

    /* Update thumbs */
    thumbs.forEach((thumb) => {
      thumb.classList.toggle(
        'is-active',
        parseInt(thumb.dataset.thumbIndex) === index
      );
    });

    /* Update counter */
    if (counter) {
      counter.textContent = `${index + 1} / ${total}`;
    }
  }

  /* Mobile: detect scroll snap position */
  if (main) {
    let scrollTimeout;
    main.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = main.scrollLeft;
          const width = main.offsetWidth;
          const newIndex = Math.round(scrollLeft / width);
          if (newIndex !== currentIndex) {
            updateActive(newIndex);
          }
        }, 50);
      },
      { passive: true }
    );
  }

  /* Listen for variant change to update gallery to variant image */
  SixSeven.on(SixSeven.Events.VARIANT_CHANGED, (e) => {
    const variant = e.detail.variant;
    if (!variant || !variant.featured_media) return;

    const mediaId = variant.featured_media.id;
    const target = gallery.querySelector(`[data-media-id="${mediaId}"]`);

    if (target) {
      const index = parseInt(target.dataset.index);
      goTo(index);
    }
  });

  /* Share button */
  const shareBtn = document.querySelector('[data-share-button]');
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const shareData = {
        title: document.title,
        url: window.location.href,
      };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
        } catch (e) {
          /* User cancelled */
        }
      } else {
        await navigator.clipboard.writeText(window.location.href);
        const original = shareBtn.textContent;
        shareBtn.textContent = 'Link copied!';
        setTimeout(() => {
          shareBtn.innerHTML = shareBtn.innerHTML;
        }, 2000);
      }
    });
  }
})();
